export class Errors {
  private errors: Record<string, string[]> = {}
  private success: boolean = false

  /**
   * Create a new Errors instance.
   */
  constructor () {
    this.errors = {}
    this.success = false
  }

  /**
   * Determine if an error exists for the given field.
   *
   * @param field - The field to check for errors
   */
  has (field: string): boolean {
    return Object.prototype.hasOwnProperty.call(this.errors, field)
  }

  /**
   * Determine if we have any errors.
   */
  any (): boolean {
    return Object.keys(this.errors).length > 0
  }

  /**
   * Retrieve the error message for a field.
   *
   * @param field - The field to get the error message for
   */
  get (field: string): string | undefined {
    if (this.errors[field]) {
      return this.errors[field][0]
    }
    return undefined
  }

  /**
   * Record the new errors.
   *
   * @param errors - The errors to record
   */
  record (errors: Record<string, string[]>): void {
    this.errors = errors
  }

  /**
   * Clear one or all error fields.
   *
   * @param field - The field to clear, or null to clear all fields
   */
  clear (field?: string | null): void {
    if (field) {
      delete this.errors[field]
      return
    }

    this.errors = {}
  }
}
